var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 24 22",
    "aria-labelledby": titleId,
    unstroked: "true",
    role: "presentation",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "box",
    lang: "en"
  }, "box icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "box",
    lang: "en"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48438 18.9843C8.48438 20.1474 9.43063 21.0937 10.5937 21.0937C11.7568 21.0937 12.7031 20.1474 12.7031 18.9843C12.7031 17.8213 11.7568 16.875 10.5937 16.875C9.43063 16.875 8.48438 17.8213 8.48438 18.9843ZM10.5937 18.2812C10.9814 18.2812 11.2968 18.5966 11.2968 18.9843C11.2968 19.372 10.9814 19.6875 10.5937 19.6875C10.206 19.6875 9.8906 19.372 9.8906 18.9843C9.8906 18.5966 10.206 18.2812 10.5937 18.2812Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5605 18.9843C15.5605 20.1474 16.5068 21.0937 17.6699 21.0937C18.833 21.0937 19.7792 20.1474 19.7792 18.9843C19.7792 17.8213 18.833 16.875 17.6699 16.875C16.5068 16.875 15.5605 17.8213 15.5605 18.9843ZM17.6699 18.2812C18.0576 18.2812 18.373 18.5966 18.373 18.9843C18.373 19.372 18.0576 19.6875 17.6699 19.6875C17.2822 19.6875 16.9668 19.372 16.9668 18.9843C16.9668 18.5966 17.2822 18.2812 17.6699 18.2812Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2965 2.81246H5.49915C5.2584 1.9697 5.03406 1.18447 4.84136 0.509992C4.75516 0.208122 4.47921 0 4.16529 0H0.703114C0.314808 0 0 0.314808 0 0.703114C0 1.09142 0.314808 1.40623 0.703114 1.40623H3.63491C4.42118 4.1585 6.25931 10.5921 7.02992 13.2893L6.76354 13.8221C6.06159 15.2261 7.08387 16.8747 8.65022 16.8747H20.4841C20.8724 16.8747 21.1872 16.5599 21.1872 16.1716C21.1872 15.7833 20.8724 15.4685 20.4841 15.4685H8.65022C8.1273 15.4685 7.78769 14.9183 8.02131 14.451L8.21565 14.0623H20.4841C20.798 14.0623 21.0739 13.8542 21.1601 13.5523L23.9726 3.70874C24.1007 3.26039 23.7638 2.81246 23.2965 2.81246ZM19.9537 12.6561H8.31151C7.92841 11.3151 6.85621 7.56246 5.90091 4.21868H22.3644L19.9537 12.6561Z",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.0bb130766f10895c98f3ec9517cdb096.svg";
export { ForwardRef as ReactComponent };